import React from 'react';
import PropTypes from 'prop-types';

import styles from './InputFieldsDiv.scss';

function InputDivWithKeys({ keys, onDeleteKey, onInputChange, inputValue, dataField }) {
    return (<div className={styles['input-div-normal']}>
        <div className={styles['input-content']}>
            {keys.map(({ id, value }) => (
                <span key={id} className={styles['input-content-item']}>
                    {value}
                    <span
                        role="presentation"
                        onClick={() => onDeleteKey(id)}
                        className={styles['input-btn-remove']}
                    >
                        ×
                    </span>
                </span>
            ))}
            <input
                type="text"
                value={inputValue}
                data-field={dataField}
                onChange={({ target }) => onInputChange(target.value)}
                className={styles['input-field-hidden-full']}
            />
        </div>
    </div>)
}

InputDivWithKeys.propTypes = {
    keys: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }),).isRequired,
    onDeleteKey: PropTypes.func.isRequired,
    onInputChange: PropTypes.func.isRequired,
    inputValue: PropTypes.string.isRequired,
    dataField: PropTypes.string,
};

InputDivWithKeys.defaultProps = {
    keys: [],
    inputValue: '',
    dataField: null,
};

export default InputDivWithKeys;
